export function initPasswordToggle({ buttonId, inputId, iconId }) {
  const btn = document.getElementById(buttonId);
  const input = document.getElementById(inputId);
  const icon = document.getElementById(iconId);

  if (!btn || !input || !icon) return;

  const iconBase = icon.getAttribute('src').replace(/[^/]+$/, '');

  btn.addEventListener('click', () => {
    const isHidden = input.type === 'password';
    input.type = isHidden ? 'text' : 'password';
    icon.src = isHidden
      ? `${iconBase}visibility_off.svg`
      : `${iconBase}Frame.svg`;
    btn.setAttribute(
      'aria-label',
      isHidden ? 'Скрыть пароль' : 'Показать пароль',
    );
  });
}
